export default "__VITE_ASSET__c_tePhkB__"